import getIdFromReference from "../../functions/getIdFromReference";
import { changeComparativeEvidenceMap } from "../../slices/comparativeEvidenceMap/comparativeEvidenceMapSlice";

const loadResourceReferenceMap = (dispatch, resourceJson, foi,
    parentResourceDetail, resourceCollection,
    isBaselineMeasureReportProfile, isParticipantFlowReportProfile, isOutcomeMeasureReportProfile,
    isComparativeEvidenceReportProfile, isComparativeEvidenceSynthesisReportProfile,
    relatedResourceCollection, relatedOutcomeMeasureReportFoi) => {
    if (resourceJson.id) {
        let measureReport = isBaselineMeasureReportProfile ||
            isParticipantFlowReportProfile ||
            isOutcomeMeasureReportProfile ||
            resourceJson.type?.text === "Outcome Measure Report" ||
            resourceJson.type?.text === "Baseline Measure Report" ||
            resourceJson.type?.text === "Participant Flow Report" ||
            resourceJson.type?.coding?.[0]?.code === "OutcomeMeasureReport" ||
            resourceJson.type?.coding?.[0]?.code === "BaselineMeasureReport" ||
            resourceJson.type?.coding?.[0]?.code === "ParticipantFlowReport";
        let isComparativeEvidenceReport = isComparativeEvidenceReportProfile ||
            resourceJson.type?.text === 'Comparative Evidence Report' ||
            resourceJson.type?.coding?.[0]?.code === "ComparativeEvidenceReport";
        let isComparativeEvidenceSynthesisReport = isComparativeEvidenceSynthesisReportProfile ||
            resourceJson.type?.text === 'Comparative Evidence Synthesis Report' ||
            resourceJson.type?.coding?.[0]?.code === "ComparativeEvidenceSynthesisReport";

        if (measureReport || isComparativeEvidenceReport ||
            isComparativeEvidenceSynthesisReport) {

            let resourceReferenceMap = {
                "compositionId": foi,
                "compositionTitle": resourceJson.title || resourceJson.name || parentResourceDetail.displayTitle
            };
            let resourceDictionary = {};
            let containedDictionary = {};
            let combinedDictionary = {};
            let groupReferencesDictionary = {};
            let groupReferencesDefinedInGroupList = false;
            let outcomeMeasures = [];
            let baselineMeasures = [];
            let participantFlowMeasures = [];
            if (measureReport && Array.isArray(resourceJson.section) && resourceJson.section.length > 0) {
                for (const sectionIndex in resourceJson.section) {
                    const section = resourceJson.section[sectionIndex];
                    if (section?.code?.text === "OutcomeGroupList" || section?.code?.text === "BaselineGroupList" ||
                        section?.code?.text === "FlowGroupList" || section?.code?.text === "GroupList") {
                        if (section.entry?.length) {
                            for (let entry of section.entry) {
                                let entryId = getIdFromReference(entry);
                                if (!groupReferencesDictionary[entryId]) {
                                    groupReferencesDictionary[entryId] = entry;
                                }
                            }
                        }
                    } else {
                        if (section?.section?.length > 0) {
                            for (const subsectionIndex in section.section) {
                                const subsection = section.section[subsectionIndex];
                                if (subsection?.code?.text === "OutcomeGroupList" || subsection?.code?.text === "BaselineGroupList" ||
                                    subsection?.code?.text === "FlowGroupList" || section?.code?.text === "GroupList") {
                                    if (subsection.entry?.length) {
                                        for (let entry of subsection.entry) {
                                            let entryId = getIdFromReference(entry);
                                            if (!groupReferencesDictionary[entryId]) {
                                                groupReferencesDictionary[entryId] = entry;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                if (Object.keys(groupReferencesDictionary).length > 0) {
                    groupReferencesDefinedInGroupList = true;
                }
            }
            if (isComparativeEvidenceReport) {
                for (const sectionIndex in resourceJson.section) {
                    const section = resourceJson.section[sectionIndex];
                    if (section?.code?.coding?.[0]?.code === "study-sample") {
                        if (section.entry?.[0]) {
                            resourceReferenceMap.populationReference = section.entry[0];
                        }
                        if (section.section?.length) {
                            for (const subsectionIndex in section.section) {
                                const subsection = section.section[subsectionIndex];
                                if (subsection?.code?.coding?.[0]?.code === "screened-group" &&
                                    subsection.entry?.[0]) {
                                    resourceReferenceMap.screenedGroupReference = subsection.entry[0];
                                } else if (subsection?.code?.coding?.[0]?.code === "enrolled-group" &&
                                    subsection.entry?.[0]) {
                                    resourceReferenceMap.enrolledGroupReference = subsection.entry[0];
                                } else if (subsection?.code?.coding?.[0]?.code === "analyzed-group" &&
                                    subsection.entry?.[0]) {
                                    resourceReferenceMap.analyzedGroupReference = subsection.entry[0];
                                } else if (subsection?.code?.coding?.[0]?.code === "eligibility-criteria" &&
                                    subsection.entry?.[0]) {
                                    resourceReferenceMap.populationDescriptionGroupReference = subsection.entry[0];
                                }
                            }
                        }
                    } else if (section?.code?.coding?.[0]?.code === "population") {
                        if (section.entry?.[0]) {
                            resourceReferenceMap.populationReference = section.entry[0];
                        }
                        if (section.section?.length) {
                            for (const subsectionIndex in section.section) {
                                const subsection = section.section[subsectionIndex];
                                if (subsection?.code?.coding?.[0]?.code === "screened-group" &&
                                    subsection.entry?.[0]) {
                                    resourceReferenceMap.screenedGroupReference = subsection.entry[0];
                                } else if (subsection?.code?.coding?.[0]?.code === "enrolled-group" &&
                                    subsection.entry?.[0]) {
                                    resourceReferenceMap.enrolledGroupReference = subsection.entry[0];
                                } else if (subsection?.code?.coding?.[0]?.code === "analyzed-group" &&
                                    subsection.entry?.[0]) {
                                    resourceReferenceMap.analyzedGroupReference = subsection.entry[0];
                                } else if (subsection?.code?.coding?.[0]?.code === "population-description" &&
                                    subsection.entry?.[0]) {
                                    resourceReferenceMap.populationDescriptionGroupReference = subsection.entry[0];
                                }
                            }
                        }
                    } else if (section?.code?.coding?.[0]?.code === "intervention-group") {
                        if (section.entry?.[0]) {
                            resourceReferenceMap.interventionGroupReference = section.entry[0];
                        }
                        if (section.section?.length) {
                            for (const subsectionIndex in section.section) {
                                const subsection = section.section[subsectionIndex];
                                if (subsection?.code?.coding?.[0]?.code === "intervention-description" &&
                                    subsection.entry?.[0]) {
                                    resourceReferenceMap.interventionDescriptionReference = subsection.entry[0];
                                }
                            }
                        }
                    } else if (section?.code?.coding?.[0]?.code === "intervention") {
                        if (section.section?.length) {
                            for (const subsectionIndex in section.section) {
                                const subsection = section.section[subsectionIndex];
                                if (subsection?.code?.coding?.[0]?.code === "intervention-description" &&
                                    subsection.entry?.[0]) {
                                    resourceReferenceMap.interventionDescriptionReference = subsection.entry[0];
                                } else if (subsection?.code?.coding?.[0]?.code === "intervention-group" &&
                                    subsection.entry?.[0]) {
                                    resourceReferenceMap.interventionGroupReference = subsection.entry[0];
                                }
                            }
                        }
                    } else if (section?.code?.coding?.[0]?.code === "comparator-group") {
                        if (section.entry?.[0]) {
                            resourceReferenceMap.comparatorGroupReference = section.entry[0];
                        }
                        if (section.section?.length) {
                            for (const subsectionIndex in section.section) {
                                const subsection = section.section[subsectionIndex];
                                if (subsection?.code?.coding?.[0]?.code === "comparator-description" &&
                                    subsection.entry?.[0]) {
                                    resourceReferenceMap.comparatorDescriptionReference = subsection.entry[0];
                                } else if (subsection?.code?.coding?.[0]?.code === "GroupAssignment" &&
                                    subsection.entry?.[0]) {
                                    resourceReferenceMap.groupAssignmentReference = subsection.entry[0];
                                }
                            }
                        }
                    } else if (section?.code?.coding?.[0]?.code === "comparator") {
                        if (section.section?.length) {
                            for (const subsectionIndex in section.section) {
                                const subsection = section.section[subsectionIndex];
                                if (subsection?.code?.coding?.[0]?.code === "comparator-description" &&
                                    subsection.entry?.[0]) {
                                    resourceReferenceMap.comparatorDescriptionReference = subsection.entry[0];
                                } else if (subsection?.code?.coding?.[0]?.code === "comparator-group" &&
                                    subsection.entry?.[0]) {
                                    resourceReferenceMap.comparatorGroupReference = subsection.entry[0];
                                } else if (subsection?.code?.coding?.[0]?.code === "GroupAssignment" &&
                                    subsection.entry?.[0]) {
                                    resourceReferenceMap.groupAssignmentReference = subsection.entry[0];
                                }
                            }
                        }
                    } else if (section?.code?.coding?.[0]?.code === "research-study") {
                        if (section.entry?.[0]) {
                            resourceReferenceMap.researchStudyReference = section.entry[0];
                        }
                    } else if (section?.code?.coding?.[0]?.code === "outcome-measures") {
                        if (section.entry?.length) {
                            for (const entry of section.entry) {
                                if (entry.type === "EvidenceVariable") {
                                    outcomeMeasures.push(entry);
                                } else if (entry.type === "List") {
                                    resourceReferenceMap.outcomeVariablesListReference = entry;
                                } else if (entry.type === "Composition") {
                                    resourceReferenceMap.outcomeMeasuresReportReference = entry;
                                }
                            }
                        }
                    } else if (section?.code?.coding?.[0]?.code === "outcome-findings") {
                        if (section.entry?.length) {
                            for (const entry of section.entry) {
                                if (entry.type === "Composition") {
                                    resourceReferenceMap.outcomeMeasuresReportReference = entry;
                                }
                            }
                        }
                    } else if (section?.code?.coding?.[0]?.code === "summary-of-findings") {
                        if (section.entry?.length) {
                            for (const entry of section.entry) {
                                if (entry.type === "List") {
                                    resourceReferenceMap.outcomeVariablesListReference = entry;
                                } else if (entry.type === "Composition") {
                                    resourceReferenceMap.summaryOfFindingsReference = entry;
                                }
                            }
                        }
                    } else if (section?.code?.coding?.[0]?.code === "screened-group") {
                        if (section.entry?.[0]) {
                            resourceReferenceMap.screenedGroupReference = section.entry[0];
                        }
                    } else if (section?.code?.coding?.[0]?.code === "excluded-group") {
                        if (section.entry?.[0]) {
                            resourceReferenceMap.excludedGroupReference = section.entry[0];
                        }
                    } else if (section?.code?.coding?.[0]?.code === "baseline-measures") {
                        if (section.entry?.length) {
                            for (const entry of section.entry) {
                                if (entry.type === "EvidenceVariable") {
                                    baselineMeasures.push(entry);
                                } else if (entry.type === "List") {
                                    resourceReferenceMap.baselineVariablesListReference = entry;
                                } else if (entry.type === "Composition") {
                                    resourceReferenceMap.baselineMeasuresReportReference = entry;
                                }
                            }
                        }
                    } else if (section?.code?.coding?.[0]?.code === "baseline-characteristics") {
                        if (section.entry?.length) {
                            for (const entry of section.entry) {
                                if (entry.type === "Composition") {
                                    resourceReferenceMap.baselineMeasuresReportReference = entry;
                                }
                            }
                        }
                    } else if (section?.code?.coding?.[0]?.code === "participant-flow-measures") {
                        if (section.entry?.length) {
                            for (const entry of section.entry) {
                                if (entry.type === "EvidenceVariable") {
                                    participantFlowMeasures.push(entry);
                                } else if (entry.type === "List") {
                                    resourceReferenceMap.participantFlowVariablesListReference = entry;
                                } else if (entry.type === "Composition") {
                                    resourceReferenceMap.participantFlowReportReference = entry;
                                }
                            }
                        }
                    } else if (section?.code?.coding?.[0]?.code === "participant-flow") {
                        if (section.entry?.length) {
                            for (const entry of section.entry) {
                                if (entry.type === "Composition") {
                                    resourceReferenceMap.participantFlowReportReference = entry;
                                } else if (entry.type === "List") {
                                    resourceReferenceMap.participantFlowVariablesListReference = entry;
                                }
                            }
                        }
                    }
                }
            }
            if (isComparativeEvidenceSynthesisReport) {
                for (const sectionIndex in resourceJson.section) {
                    const section = resourceJson.section[sectionIndex];
                    if (section?.code?.coding?.[0]?.code === "population") {
                        if (section.entry?.[0]) {
                            resourceReferenceMap.synthesisPopulationReference = section.entry[0];
                        }
                    } else if (section?.code?.coding?.[0]?.code === "intervention-description") {
                        if (section.entry?.[0]) {
                            resourceReferenceMap.synthesisInterventionDescriptionReference = section.entry[0];
                        }
                    } else if (section?.code?.coding?.[0]?.code === "comparator-description") {
                        if (section.entry?.[0]) {
                            resourceReferenceMap.synthesisComparatorDescriptionReference = section.entry[0];
                        }
                    } else if (section?.code?.coding?.[0]?.code === "research-study") {
                        if (section.entry?.[0]) {
                            resourceReferenceMap.researchStudyReference = section.entry[0];
                        }
                    } else if (section?.code?.coding?.[0]?.code === "variables") {
                        if (section.entry?.length) {
                            for (const entry of section.entry) {
                                if (entry.type === "List") {
                                    resourceReferenceMap.outcomeVariablesListReference = entry;
                                } else if (entry.type === "EvidenceVariable") {
                                    outcomeMeasures.push(entry);
                                }
                            }
                        }
                    } else if (section?.code?.coding?.[0]?.code === "results") {
                        if (section.entry?.length) {
                            for (const entry of section.entry) {
                                if (entry.type === "Composition") {
                                    resourceReferenceMap.outcomeMeasuresReportReference = entry;
                                }
                            }
                        }
                    } else if (section?.code?.coding?.[0]?.code === "summary-of-findings") {
                        if (section.entry?.length) {
                            for (const entry of section.entry) {
                                if (entry.type === "Composition") {
                                    resourceReferenceMap.summaryOfFindingsReference = entry;
                                }
                            }
                        }
                    }
                }
            }
            for (const entry of resourceCollection) {
                resourceDictionary[entry.id] = entry.resourceJson;
                if (measureReport && entry.resourceType === "Evidence") {
                    if (!groupReferencesDefinedInGroupList) {
                        if (entry.resourceJson.meta?.profile?.[0] === "http://hl7.org/fhir/uv/ebm/StructureDefinition/comparative-evidence" &&
                            entry.resourceJson.variableDefinition?.[1]?.variableRole === "exposure") {
                            let referenceObject = entry.resourceJson.variableDefinition[1].observed || entry.resourceJson.variableDefinition[1].intended;
                            let entryId = getIdFromReference(referenceObject);
                            if (!groupReferencesDictionary[entryId]) {
                                groupReferencesDictionary[entryId] = referenceObject;
                            }
                        } else if (entry.resourceJson.variableDefinition?.[0]?.variableRole === "population") {
                            let referenceObject = entry.resourceJson.variableDefinition[0].observed || entry.resourceJson.variableDefinition[0].intended;
                            let entryId = getIdFromReference(referenceObject);
                            if (!groupReferencesDictionary[entryId]) {
                                groupReferencesDictionary[entryId] = referenceObject;
                            }
                        }
                    }
                }
                combinedDictionary[entry.id] = entry.resourceJson;
            }
            if (relatedOutcomeMeasureReportFoi) {
                for (const entry of relatedResourceCollection) {
                    combinedDictionary[entry.id] = entry.resourceJson;
                }
            }
            if (Array.isArray(resourceJson.contained) && resourceJson.contained.length > 0) {
                for (const item of resourceJson.contained) {
                    containedDictionary[item.id] = item;
                    if (measureReport && item.resourceType === "Evidence") {
                        if (!groupReferencesDefinedInGroupList) {
                            if (item.meta?.profile?.[0] === "http://hl7.org/fhir/uv/ebm/StructureDefinition/comparative-evidence" &&
                                item.variableDefinition?.[1]?.variableRole === "exposure") {
                                let entry = item.variableDefinition[1].observed || item.variableDefinition[1].intended;
                                let entryId = getIdFromReference(entry);
                                if (!groupReferencesDictionary[entryId]) {
                                    groupReferencesDictionary[entryId] = entry;
                                }
                            } else if (item.variableDefinition?.[0]?.variableRole === "population") {
                                let entry = item.variableDefinition[0].observed || item.variableDefinition[0].intended;
                                let entryId = getIdFromReference(entry);
                                if (!groupReferencesDictionary[entryId]) {
                                    groupReferencesDictionary[entryId] = entry;
                                }
                            }
                        }
                    }
                    combinedDictionary[item.id] = item;
                }
            }
            if (resourceReferenceMap.researchStudyReference?.type === "ResearchStudy") {
                let researchStudyFoi = resourceReferenceMap.researchStudyReference.reference.replace("ResearchStudy/", "").replace("#", "");
                if (researchStudyFoi && combinedDictionary[researchStudyFoi]) {
                    resourceReferenceMap["researchStudyJson"] = combinedDictionary[researchStudyFoi];
                }
            }

            resourceReferenceMap["combinedDictionary"] = combinedDictionary;
            resourceReferenceMap["groupReferencesDictionary"] = groupReferencesDictionary;
            resourceReferenceMap["outcomeMeasures"] = outcomeMeasures;
            resourceReferenceMap["baselineMeasures"] = baselineMeasures;
            resourceReferenceMap["participantFlowMeasures"] = participantFlowMeasures;
            dispatch(changeComparativeEvidenceMap(resourceReferenceMap));
        }
    }
}

export default loadResourceReferenceMap;